define([
    'underscore',
    'edge/platform/util/LocalDateUtil',
    'edge/platform/util/DateUtil',
], (_, LocalDateUtil, DateUtil) => {
    return ['BaslerDateUtilService', (BaslerDateUtilService) => {
        const service = {
            validateMatriculationNumber,
            validateMatriculationNumbersUnique,
            validatePaidTransportOfGoodsUse,
            comparePeriodStartAndBirthDate,
            comparePeriodStartAndFirstRegistration,
            validateRegistrationDate,
            replaceAll,
            toLowerCase,
            validateVehicleDrivers,
        };

        function validateMatriculationNumber(matriculationNumber) {
            return validateFormat(matriculationNumber) && validateNotOnlyZeroes(matriculationNumber) && validateChecksum(matriculationNumber);

            function validateFormat(actMatriculationNumber) {
                const pattern = new RegExp('((^)[0-9]{3}\\.?[0-9]{3}\\.?[0-9]{3}($))');
                return pattern.test(actMatriculationNumber);
            }

            function validateNotOnlyZeroes(actMatriculationNumber) {
                const matNr = actMatriculationNumber.replace(/\./g, '');
                return matNr !== '000000000';
            }

            function validateChecksum(actMatriculationNumber) {
                const matNr = actMatriculationNumber.replace(/\./g, '');
                if (!_.isEmpty(matNr)) {
                    let checkValue = 0;
                    const factors = [3, 2, 7, 6, 5, 4, 3, 2];
                    for (let i = 0; i < factors.length; ++i) {
                        checkValue += (matNr.substring(i, i + 1)) * factors[i];
                    }
                    const checkValueMatriculationNumber = matNr.substring(8, 9);
                    let checkValueCalculated = (checkValue % 11);
                    if (checkValueCalculated > 9) {
                        checkValueCalculated = 0;
                    }
                    return checkValueMatriculationNumber === String(checkValueCalculated);
                }
                return true;
            }
        }

        // Returns true if the matriculation numbers are unique or undefined
        function validateMatriculationNumbersUnique(vehicles) {
            const nrs = vehicles.map(v => v.matriculationInformation.matriculationNumber).filter(nr => nr !== undefined);
            return nrs.length === new Set(nrs).size;
        }

        function validateVehicleDrivers(vehicles, drivers) {
            return Boolean(vehicles && vehicles.some(vehicle => vehicle.hasVariousDrivers)) !==
                Boolean(drivers && drivers.length > 0)
        }

        // Mark the field 'PaidTransportOfGoodsUse' conditionally (only for delivery vans) required
        function validatePaidTransportOfGoodsUse(vehicles) {
            for (let i = 0; i < vehicles.length; ++i) {
                if (vehicles[i].vehicleCategory === 'DeliveryVan') {
                    return true;
                }
            }
            return false;
        }

        function comparePeriodStartAndBirthDate(periodStartDate, dateOfBirth) {
            if (periodStartDate && dateOfBirth) {
                return periodStartDate.year - dateOfBirth.getFullYear() > 15;
            }
            return true;
        }

        function comparePeriodStartAndFirstRegistration(draftDataDTO) {
            const {vehicles} = draftDataDTO.lobs.mFPLine;
            let insuranceDate = LocalDateUtil.toMidnightDate(draftDataDTO.periodStartDate);
            insuranceDate = BaslerDateUtilService.addDays(insuranceDate, 14);
            return _.all(vehicles, vehicle => insuranceDate > DateUtil.trimToMidnight(vehicle.firstRegistration));
        }

        function validateRegistrationDate(periodStartDate, registrationDate) {
            if (periodStartDate && registrationDate) {
                const registration = BaslerDateUtilService.addDays(LocalDateUtil.toMidnightDate(registrationDate), 16);
                return registration >= LocalDateUtil.toMidnightDate(periodStartDate);
            }
            return false;
        }

        /**
         * Replaces each substring of the source string that matches the given regex with the
         * given replacement.
         */
        function replaceAll(source, str, replacement) {
            return source && str && (replacement || replacement === '') ? source.replace(new RegExp(str, 'g'), replacement) : source;
        }

        /**
         * Returns the given string in lower case
         */
        function toLowerCase(str) {
            return str ? str.toLowerCase() : str;
        }

        return service;
    }];
});




// WEBPACK FOOTER //
// ../common/js/src/edge/quoteandbind/mfp/services/MFPValidationService.js